(() => {
  const init = () => {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;
    const top = document.createElement('div');
    top.setAttribute('data-sh-top-sentinel', '');
    top.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:8px;pointer-events:none;';
    document.body.prepend(top);
    new IntersectionObserver(([entry]) => header.classList.toggle('sh-header--scrolled', !entry.isIntersecting), { threshold: 0 }).observe(top);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
